import { transition } from '@angular/animations';
import { InstancesService } from './../../auth/instances.service';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit {

  codiceLingua = '';
  translation = '';

  constructor(
    private http: HttpClient,
    private instanceService: InstancesService
  ) { }

  ngOnInit(): void {

    this.instanceService.getInstance()
    .subscribe((res: {data: any}) => {
      const instanceId = res.data.id;
      this.codiceLingua = (instanceId === 1) ? 'it' : 'en';
      this.http.get(environment.apiUrl + '/lang/' + this.codiceLingua)
      .subscribe((res: {data: any}) => {
        this.translation = JSON.stringify(res.data.translation, null, "\t");
        
      })
    })
  }

  updateLanguage(): void {
    this.http.post(environment.apiUrl + '/lang', {lang: this.codiceLingua, translation: JSON.parse(this.translation)})
    .subscribe((res: {data: any}) => {
      console.log(res);
    })
  }

}
